module.exports = __webpack_public_path__ + "img/Goal_5.0f0ff7b4.png";